import React from 'react';
import PropTypes from 'prop-types';
import './LockerComparisonTable.scss';

export function LockerComparisonTable({
	rows,
	lockerColumnLabel,
	regularColumnLabel,
}) {
	return (
		<table className="locker-comparison-table">
			<thead>
				<tr>
					<th className="locker-comparison-table__th locker-comparison-table__th--feature">
						Feature
					</th>
					<th className="locker-comparison-table__th">
						{lockerColumnLabel}
					</th>
					<th className="locker-comparison-table__th">
						{regularColumnLabel}
					</th>
				</tr>
			</thead>
			<tbody>
				{rows.map((row) => (
					<tr
						key={row.feature}
						className="locker-comparison-table__row"
					>
						<td className="locker-comparison-table__td locker-comparison-table__td--feature">
							{row.feature}
						</td>
						<td className="locker-comparison-table__td">
							{row.locker}
						</td>
						<td className="locker-comparison-table__td">
							{row.regular}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

LockerComparisonTable.propTypes = {
	lockerColumnLabel: PropTypes.string.isRequired,
	regularColumnLabel: PropTypes.string.isRequired,
	rows: PropTypes.arrayOf(
		PropTypes.shape({
			feature: PropTypes.string.isRequired,
			locker: PropTypes.string.isRequired,
			regular: PropTypes.string.isRequired,
		}),
	).isRequired,
};

export default LockerComparisonTable;
